import { axios } from "lib/axios"

export const subscribe = async (data) => {
  const jsonData = {
    "email": data.email,
    "source": "website",
    "subscription_status": "subscribed",
    "type": data.type,
    "cf-turnstile-response": data["cf-turnstile-response"],
  }

  return await axios.post("/newsletter/subscribe", JSON.stringify(jsonData));
}

